export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-subscript-8a6fe2d0e9646e440051aab04323e1a0.svg";